import React, { useEffect, useState } from 'react';
import Loader from '../components/Loader';
import ErrorBoundary from '../components/ErrorBoundary';
import Layout from '../components/Layout';
import { FaDownload, FaSearch } from 'react-icons/fa';

const Reports = () => {
  const [shipments, setShipments] = useState([]);
  const [filteredShipments, setFilteredShipments] = useState([]);
  const [selectedShipments, setSelectedShipments] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showOnlySelected, setShowOnlySelected] = useState(false);
  const [meta, setMeta] = useState({ totalItems: 0, totalPages: 1, currentPage: 1 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_BASE_URL;

  const fetchShipment = async (page = 1) => {
    setError(null);
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/api/shipments?page=${page}`);
      if (!response.ok) {
        throw new Error('Failed to fetch shipments');
      }
      const data = await response.json();
      setShipments(data.shipments);
      setFilteredShipments(data.shipments); // Initialize filtered shipments
      setMeta(data.meta);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetchShipment(meta.currentPage);
    setShipments(
      [
        {
          "shipment_number": "OCEAN2023-1",
          "vessel_number": "MSCGSL135",
          "origin": "CNGGZ",
          "destination": "USLAX",
          "carrier_id": "MSCU",
          "departs_on": "2023-11-01T08:00:00Z",
          "arrive_on": "2023-12-15T16:30:00Z",
          "manifest_weight": "24,500 kg"
        },
        {
          "shipment_number": "AIRF456-7B",
          "vessel_number": "UPS605",
          "origin": "DEHAM",
          "destination": "JPTYO",
          "carrier_id": "UPS",
          "departs_on": "2023-11-05T12:30:00Z",
          "arrive_on": "2023-11-06T05:45:00Z",
          "manifest_weight": "8,200 kg"
        },
        {
          "shipment_number": "TRUCK-789X",
          "vessel_number": "FEDX-8876",
          "origin": "USCHI",
          "destination": "CATOR",
          "carrier_id": "FEDEX",
          "departs_on": "2023-11-10T06:00:00Z",
          "arrive_on": "2023-11-12T18:00:00Z",
          "manifest_weight": "15,000 kg"
        },
        {
          "shipment_number": "RAIL-445R",
          "vessel_number": "BNSF2345",
          "origin": "USLNK",
          "destination": "USDAL",
          "carrier_id": "BNSF",
          "departs_on": "2023-11-15T09:15:00Z",
          "arrive_on": "2023-11-16T14:20:00Z",
          "manifest_weight": "32,000 kg"
        },
        {
          "shipment_number": "SHIP-952A",
          "vessel_number": "MAERSK632",
          "origin": "NLRTM",
          "destination": "SGSIN",
          "carrier_id": "MAEU",
          "departs_on": "2023-11-20T20:00:00Z",
          "arrive_on": "2023-12-05T08:00:00Z",
          "manifest_weight": "48,750 kg"
        },
        {
          "shipment_number": "EXPRESS-77F",
          "vessel_number": "DHL888",
          "origin": "HKHKG",
          "destination": "AUSYD",
          "carrier_id": "DHL",
          "departs_on": "2023-11-25T15:45:00Z",
          "arrive_on": "2023-11-27T07:30:00Z",
          "manifest_weight": "5,500 kg"
        },
        {
          "shipment_number": "COASTAL-12C",
          "vessel_number": "COSCO987",
          "origin": "USSEA",
          "destination": "CAVAN",
          "carrier_id": "COSU",
          "departs_on": "2023-12-01T07:00:00Z",
          "arrive_on": "2023-12-03T12:00:00Z",
          "manifest_weight": "18,300 kg"
        },
        {
          "shipment_number": "INTERMODAL-X",
          "vessel_number": "JBU45",
          "origin": "FRPAR",
          "destination": "ITMIL",
          "carrier_id": "JBHT",
          "departs_on": "2023-12-05T10:30:00Z",
          "arrive_on": "2023-12-06T09:00:00Z",
          "manifest_weight": "22,100 kg"
        },
        {
          "shipment_number": "REEFER-889",
          "vessel_number": "HMM234",
          "origin": "ESBCN",
          "destination": "BRSSZ",
          "carrier_id": "HMMG",
          "departs_on": "2023-12-10T13:00:00Z",
          "arrive_on": "2023-12-25T08:45:00Z",
          "manifest_weight": "14,800 kg"
        },
        {
          "shipment_number": "LCL-335T",
          "vessel_number": "EVERGREEN77",
          "origin": "CNTSN",
          "destination": "USNYC",
          "carrier_id": "EGLV",
          "departs_on": "2023-12-15T18:00:00Z",
          "arrive_on": "2024-01-05T10:00:00Z",
          "manifest_weight": "9,750 kg"
        }
      ]
    )
  }, [meta.currentPage]);

  useEffect(() => {
    let displayedShipments = shipments;

    if (searchQuery) {
      displayedShipments = shipments.filter(
        (shipment) =>
          shipment.shipment_number.toLowerCase().includes(searchQuery.toLowerCase()) ||
          shipment.vessel_number.toLowerCase().includes(searchQuery.toLowerCase()) ||
          shipment.origin.toLowerCase().includes(searchQuery.toLowerCase()) ||
          shipment.destination.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (showOnlySelected) {
      displayedShipments = displayedShipments.filter((shipment) =>
        selectedShipments.includes(shipment.id)
      );
    }

    setFilteredShipments(displayedShipments);
  }, [searchQuery, shipments, showOnlySelected, selectedShipments]);

  const handleSelectShipment = (id) => {
    setSelectedShipments((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((shipmentId) => shipmentId !== id)
        : [...prevSelected, id]
    );
  };

  const handlePageChange = (page) => {
    setMeta((prevMeta) => ({ ...prevMeta, currentPage: page }));
  };

  const generateXmlReport = () => {
    const selectedShipmentData = shipments.filter((shipment) =>
      selectedShipments.includes(shipment.id)
    );

    const xmlContent = `
      <Shipments>
        ${selectedShipmentData
          .map(
            (shipment) => `
          <Shipment>
            <ShipmentNumber>${shipment.shipment_number}</ShipmentNumber>
            <CarrierId>${shipment.carrier_id}</CarrierId>
            <Origin>${shipment.origin}</Origin>
            <Destination>${shipment.destination}</Destination>
            <DepartsOn>${shipment.departs_on}</DepartsOn>
            <ArriveOn>${shipment.arrive_on}</ArriveOn>
            <VesselNumber>${shipment.vessel_number}</VesselNumber>
            <ManifestWeight>${shipment.manifest_weight}</ManifestWeight>
            <FreightType>${shipment.freight_type_id}</FreightType>
          </Shipment>
        `
          )
          .join('')}
      </Shipments>
    `;

    const blob = new Blob([xmlContent], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'shipment_report.xml';
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading) {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="alert alert-error">Error: {error}</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="card w-full p-6 bg-base-100 shadow-xl">
        

        {/* Search and Filters */}
        <div className="card lg:h-full w-4/5 lg:w-full  p-6 bg-base-100 shadow-xl">
          <div className="form-control">
            <div className="input-group">
              <input
                type="text"
                placeholder="Search shipments..."
                className="input input-bordered"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button className="btn btn-primary">
                <FaSearch />
              </button>
            </div>
            
          </div>

          <h1 className="text-2xl font-bold mb-6">Reports</h1> 

       
          
          <div className="form-control">
            <label className="cursor-pointer label">
              <span className="label-text mr-2">Show Only Selected</span>
              <input
                type="checkbox"
                className="checkbox checkbox-primary"
                checked={showOnlySelected}
                onChange={(e) => setShowOnlySelected(e.target.checked)}
              />
            </label>
          </div>

          

          <p className="text-lg font-semibold">
            Selected Shipments: {selectedShipments.length}
          </p>

            {/* Generate Report Button */}
         <button
          className="btn btn-primary mt-6"
          onClick={generateXmlReport}
          disabled={selectedShipments.length === 0}
        >
          <FaDownload className="mr-2" /> Generate XML Report
        </button>
        </div>

        

        {/* Shipment List */}
        {filteredShipments.length === 0 ? (
          <p className="text-center">No shipments match your criteria.</p>
        ) : (
          <ul className="space-y-4">
            {filteredShipments.map((shipment) => (
              <li
                key={shipment.id}
                className="p-4 border rounded shadow flex items-center gap-4 bg-white"
              >
                <input
                  type="checkbox"
                  className="checkbox checkbox-primary"
                  checked={selectedShipments.includes(shipment.id)}
                  onChange={() => handleSelectShipment(shipment.id)}
                />
                <div className="flex-1">
                  <h2 className="text-xl font-semibold">
                    {shipment.shipment_number}
                  </h2>
                  <p className="text-gray-600">
                    Vessel Number: {shipment.vessel_number}
                  </p>
                  <p className="text-sm text-gray-500">
                    Origin: {shipment.origin} | Destination: {shipment.destination}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        )}

        {/* Pagination */}
        <div className="btn-group justify-center mt-6">
          {[...Array(meta.totalPages)].map((_, index) => (
            <button
              key={index}
              className={`btn ${
                meta.currentPage === index + 1 ? 'btn-active' : ''
              }`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>

       
      </div>
    </Layout>
  );
};

const WrappedReports = () => (
  <ErrorBoundary>
    <Reports />
  </ErrorBoundary>
);

export default WrappedReports;
